import {Box, Grid, Image} from '@yandex-delivery/blocks'

import {tagToUrl} from '../../lib/tagToUrl'
import {renderWidget} from '..'
import type {ImageWidgetProps as Props} from '../types'

export const ImageWidget = ({
  config: {
    height,
    text,
    image: {image_tag},
  },
}: Props): React.ReactElement => {
  return (
    <Grid>
      <Image alt="" height={height} src={tagToUrl(image_tag)} />
      {text && <Box flexDirection="column">{text.items.map(renderWidget)}</Box>}
    </Grid>
  )
}
